import { FC, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  Box,
  ContentLabelField,
  ContentList,
  Divider,
  EmailListInput,
  Grid,
  Text,
  Toggle,
} from '@hopskipdrive/react-components';
import { colorTokens } from '@rideiq/shared/components/variables';

import { EmailListContainer, ListInfo } from './styles';

export interface AbsentRiderNotificationsProps {
  sendEmailDailyReport?: string;
  dailyReportEmailList?: string;
  editMode: boolean;
}

const AbsentRiderNotifications: FC<AbsentRiderNotificationsProps> = ({
  sendEmailDailyReport,
  dailyReportEmailList,
  editMode,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const [showEmailList, setShowEmailList] = useState(sendEmailDailyReport === 'Yes');

  const updateToggle = (e) => {
    setShowEmailList(e?.target?.value === 'Yes');
  };

  return (
    <Box>
      <Grid container>
        <Grid item xs={6} data-settings-column>
          <ContentList mb={4}>
            <Text variant="h3" fontWeight={600}>
              Absent Riders
            </Text>
          </ContentList>
          <ContentLabelField
            id="sendEmailDailyReport"
            title="Send Email with Daily Report"
            description={sendEmailDailyReport}
            editMode={editMode}
            editView={
              <Controller
                render={({ field: { value, onChange, onBlur } }) => (
                  <Toggle
                    value={value}
                    onBlur={onBlur}
                    onChange={(e) => {
                      updateToggle(e);
                      onChange(e);
                    }}
                    exclusive
                  >
                    <Toggle.Option value="Yes" key="Yes">
                      Yes
                    </Toggle.Option>
                    <Toggle.Option value="No" key="No">
                      No
                    </Toggle.Option>
                  </Toggle>
                )}
                name="sendEmailDailyReport"
                control={control}
              />
            }
          />

          {showEmailList && (
            <ContentLabelField
              id="dailyReportEmailList"
              title="Email Addresses"
              description={dailyReportEmailList}
              editMode={editMode}
              editView={
                <Controller
                  render={({ field: { value, onChange } }) => (
                    <EmailListContainer>
                      <EmailListInput
                        value={value}
                        errorMessage={errors.dailyReportEmailList?.message?.toString()}
                        onChange={onChange}
                        placeholder="email1@email.com, email2@email.com, email3@email.com"
                      />
                    </EmailListContainer>
                  )}
                  name="dailyReportEmailList"
                  control={control}
                />
              }
            />
          )}
        </Grid>
        <Grid item xs={1} style={{ maxWidth: '40px' }} data-settings-divider>
          <Divider orientation="vertical" style={{ width: '1px' }} />
        </Grid>
        <Grid item xs={3} md={4} data-settings-column data-settings-explanation>
          <Box>
            <Box bgcolor={colorTokens.background.light} pb={4}>
              <ContentList>
                <Text p={8} pb={0} fontWeight={600}>
                  This is a daily report that will be sent to all email addresses added in the “Email Addresses”
                  section.
                </Text>
              </ContentList>
              <ContentList>
                <Text p={8} pt={0} pb={0}>
                  The report includes all riders with at least one no-show over the past 7 days. The email will include
                  AM rides up till 9:30AM local time and be sent to these email addresses at 10AM local time.
                </Text>
              </ContentList>
              <ContentList>
                <Text p={8} pt={0} pb={0}>
                  The report will include:
                </Text>
              </ContentList>
              <ContentList>
                <ListInfo>
                  <li className={'orange'}>
                    <Text className={'test-css'}>Rider Name</Text>
                  </li>
                  <li className={'orange'}>
                    <Text>Rider External ID</Text>
                  </li>
                  <li className={'orange'}>
                    <Text>Rider Category</Text>
                  </li>
                  <li className={'orange'}>
                    <Text>Consecutive No-Shows/Cancellations</Text>
                  </li>
                  <li className={'orange'}>
                    <Text>Total No-Shows/Cancellations</Text>
                  </li>
                  <li className={'orange'}>
                    <Text>Dates</Text>
                  </li>
                  <li className={'orange'}>
                    <Text>Next Ride</Text>
                  </li>
                  <li className={'orange'}>
                    <Text>Total Billed Canceled Rides</Text>
                  </li>
                  <li className={'orange'}>
                    <Text>Total Billed Amount</Text>
                  </li>
                  <li className={'orange'}>
                    <Text>Number of Billed Rides</Text>
                  </li>
                  <li className={'orange'}>
                    <Text>Number of Billed Cancels</Text>
                  </li>
                  <li className={'orange'}>
                    <Text>Cancellation rate</Text>
                  </li>
                </ListInfo>
              </ContentList>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AbsentRiderNotifications;
